module.exports = "https://static.wanderu.com/static/media/warning.e7840e98.svg";